import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';
import { ConvenioDto, ConvenioServiceProxy, CreateConvenioDto, CreateEnderecoDto } from '@shared/service-proxies/service-proxies';
import { FormEnderecoComponent } from '@shared/components/form-endereco/form-endereco.component';
import { StringUtils } from '@shared/helpers/StringUtils';
import { finalize } from 'rxjs/operators';
import { cnpj } from 'cpf-cnpj-validator';

@Component({
  selector: 'app-create-convenio',
  templateUrl: './create-convenio.component.html',
})

export class CreateConvenioComponent extends AppComponentBase {
  public convenio: CreateConvenioDto = new CreateConvenioDto();
  public saving: boolean = false;
  public shouldValidateEndereco: boolean = false;
  @Output() onSave = new EventEmitter<ConvenioDto>();
  @ViewChild("formEndereco") formEndereco: FormEnderecoComponent;
  @ViewChild('tabs') tabs;

  constructor(
    injector: Injector,
    private _convenioService: ConvenioServiceProxy,
    public bsModalRef: BsModalRef
  ) { super(injector) }

  protected save() {

  if (!this.IsFormValided()) {
    this.tabs.selectedIndex = 0;
    return;
  }

  if (!this.shouldValidateEndereco) {
    this.shouldValidateEndereco = true;
    this.tabs.selectedIndex = 1;
    return;
  }

  if (!this.formEndereco.IsFormValided()) {
    this.tabs.selectedIndex = 1;
    return;
  }

  abp.ui.setBusy();
  this.saving = true;

  this.convenio.endereco = CreateEnderecoDto.fromJS(this.formEndereco.endereco.toJSON());
  this.convenio.autoGestao = true;

  this._convenioService.create(this.convenio).pipe(
    finalize(() => {
      abp.ui.clearBusy();
      this.saving = false;
    })
  ).subscribe(result => {
    this.onSave.emit(result);
    this.bsModalRef.hide();
  });
}



  protected IsFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.convenio.cnpj), message: "Informe o CNPJ." },
      { condition: !cnpj.isValid(this.convenio.cnpj), message: "CNPJ inválido." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.razaoSocial), message: "Informe a razão social." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.email), message: "Informe o email." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.representante), message: "Informe o nome do representante." },
      { condition: StringUtils.isNullOrEmpty(this.convenio.cargoRepresentante), message: "Informe o cargo do representante." },
    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  protected onChangeCnpj($event) {
    this.convenio.cnpj = $event;
    if ($event.length == 14) {
      abp.ui.setBusy()
      this._convenioService.getInformacoesEmpresa($event).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe(empresa => {
        if (empresa) {
          this.convenio.razaoSocial = empresa.razaoSocial;
          this.convenio.telefone = empresa.telefone;
          this.convenio.nomeFantasia = empresa.nomeFantasia;
          this.convenio.email = empresa.email;
          this.convenio.ddd = empresa.ddd;
        }
      });
    }
  }
}
